import { palette } from '../../styles/tokens';
import type { ScheduleEntry } from '../../types';
import { formatTime12, getEntryColor, ENTRY_TYPE_LABELS } from '../../components/schedule/scheduleHelpers';

interface Props {
  entry: ScheduleEntry;
  timePreview?: string | null; // e.g. "10:30 AM → 11:15 AM"
}

export function DragOverlayCard({ entry, timePreview }: Props) {
  const color = getEntryColor(entry);
  const label = ENTRY_TYPE_LABELS[entry.type as keyof typeof ENTRY_TYPE_LABELS] ?? entry.type;

  return (
    <div style={{
      padding: '6px 10px', borderRadius: 6, background: palette.white,
      border: `1px solid ${color}`, borderLeft: `3px solid ${color}`,
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)', minWidth: 140, maxWidth: 220,
      transform: 'scale(1.02)', cursor: 'grabbing',
    }}>
      <div style={{ fontSize: 9, fontWeight: 600, color, textTransform: 'uppercase', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 12, fontWeight: 600, color: palette.g800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{entry.title}</div>
      {timePreview ? (
        <div style={{ fontSize: 10, fontWeight: 600, color: palette.accent, marginTop: 1 }}>{timePreview}</div>
      ) : (
        <div style={{ fontSize: 10, color: palette.g500 }}>
          {entry.all_day ? 'All day' : `${formatTime12(entry.start_at)} – ${formatTime12(entry.end_at)}`}
        </div>
      )}
    </div>
  );
}
